import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Button } from 'antd';

var _excluded = ["disabled", "children", "label", "type", "className", "style"];
var getClassByTyle = function getClassByTyle(type) {
  switch (type) {
    case 'icon':
      return 'dm-btn-type-icon';
    default:
      // AS ANT DESIGN ADD CLASSES AUTOMATICALLY FOR OTHER TYPES WE RETURN EMPTY
      return '';
  }
};
/**
 * Primary UI component for user interaction
 */
var DmButton = function DmButton(_ref) {
  var disabled = _ref.disabled,
    children = _ref.children,
    label = _ref.label,
    type = _ref.type,
    className = _ref.className,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Button, _extends({
    type: type,
    className: "dm-button ".concat(getClassByTyle(type), " ").concat(className),
    style: style,
    disabled: Boolean(disabled)
  }, props), label || children);
};
DmButton.defaultProps = {
  disabled: false
};

export { DmButton };
